import DateFnsUtils from "@date-io/date-fns";
import {
    Button, CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, FormControl, IconButton, Paper,
    TextField,
    Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ClearIcon from "@material-ui/icons/Clear";
import { Autocomplete } from "@material-ui/lab";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from "../../../assets/globalStyles";
import { validate, validateHelper } from "../../../features/validate/validate";
import { messgeraet, messgeraettyp, wartungsintervall } from "../../../utils/apiTypes";
import { isAuthorized, rollen } from "../../../utils/auth/authConfig";
import {
    createMessgeraet, deleteMessgeraet, discardChanges, discardNew, resetError, selectAktuellesMessgeraet, selectEditDirty, selectEditEntry, selectError, selectListLoading, selectMessgeraetetyp, selectMessgeraettypenLoading, selectNewEntry, selectViewMode, selectWartungsintervalleList, selectWartungsintervallLoading,
    selectZeitsynchroLoading, selectZSs, setEditEntry, setError, setFirmware, setHerstellungsjahr, setInbetriebnahmedatum, setIp, setKommentar, setMACAdresse, setMessgeraetetyp, setSeriennummer, setSubnetzmaske, setWartungsintervall, setZS, updateMessgeraet, resetViewMode
} from "./messgeraeteSlice";
import { useStyles } from "./messgeraeteStyles";
import { zeitsynchronisationsart } from './messgeraeteTypes';
import { de } from "date-fns/locale";

export const MessgeraeteEdit: React.FC = () => {
    const dispatch = useAppDispatch();

    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const zsSelectList: zeitsynchronisationsart[] = useAppSelector(selectZSs),
        messgeraettypSelectList: messgeraettyp[] = useAppSelector(selectMessgeraetetyp),
        editEntry: boolean = useAppSelector(selectEditEntry),
        newEntry: boolean = useAppSelector(selectNewEntry),
        aktuellesMessgeraet: messgeraet = useAppSelector(selectAktuellesMessgeraet),
        viewMode: boolean = useAppSelector(selectViewMode),
        dirtyEdit: number = useAppSelector(selectEditDirty),
        inputError: boolean = useAppSelector(selectError),
        wartungsintervalleSelectList: Array<wartungsintervall> = useAppSelector(selectWartungsintervalleList),
        listLoading: boolean = useAppSelector(selectListLoading),
        messgeraettypenLoading: boolean = useAppSelector(selectMessgeraettypenLoading),
        zeitsynchroLoading: boolean = useAppSelector(selectZeitsynchroLoading),
        wartungsintervallLoading: boolean = useAppSelector(selectWartungsintervallLoading);


    function printSaveDiscardButtons() {
        return (<div>
            <Button
                variant="contained"
                onClick={() => { newEntry ? dispatch(createMessgeraet(aktuellesMessgeraet)) : dispatch(updateMessgeraet(aktuellesMessgeraet)) }}
                color="secondary"
                className={classes.showtriButton}
                disabled={aktuellesMessgeraet.seriennummer == ""
                    || aktuellesMessgeraet.typ == -1
                    || aktuellesMessgeraet.firmware == ""
                    || !dirtyEdit
                    || inputError}
                style={{ minHeight: "36px" }}
            >
                {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
            </Button>
            <Button
                variant="contained"
                onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
                color="secondary"
                className={classes.showtriButton}
            >
                Abbrechen
            </Button>
        </div>)
    }
    function confirmDeleteOfMessgeraet() {
        dispatch(deleteMessgeraet(aktuellesMessgeraet));
        setOpenDeleteDialog(false);
    }

    function printEditDeleteButton() {
        if (isAuthorized([rollen.admin, rollen.betrieb])) {
            return (
                <div>
                    <Button
                        variant="contained"
                        onClick={() => {
                            dispatch(setEditEntry())

                        }}
                        color="secondary"
                        className={classes.showtriButton}
                    >
                        Bearbeiten
                    </Button>

                    {!aktuellesMessgeraet.jemalsZugeordnet ? 
                    <Button
                        variant="contained"
                        onClick={() => setOpenDeleteDialog(true)}
                        className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
                    >
                        Löschen
                    </Button>
                    : ""}
                    <Dialog
                        open={openDeleteDialog}
                        onClose={() => setOpenDeleteDialog(false)}
                    >
                        <DialogTitle>Messstelle löschen</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {'Sind Sie sicher, dass Sie das Messgerät "' +
                                    aktuellesMessgeraet.seriennummer +
                                    '" wirklich löschen wollen?'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => setOpenDeleteDialog(false)}
                                className={classes.cancleDeleteButton}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                variant="contained"
                                onClick={confirmDeleteOfMessgeraet}
                                className={classes.confirmDeleteButton}
                                style={{ minWidth: "120px", minHeight: "36px" }}
                            >
                                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Button
                        variant="contained"
                        onClick={() => { dispatch(resetViewMode())}}
                        color="default"
                        className={classes.showtriButton}
                    >
                        Schließen
                    </Button>
                </div>
            );
        }
        else {
            return (<React.Fragment />)
        }
    }


    const [zsSelectInputValue, setZSSelectInputValue] = React.useState('');
    const [messgeraettypSelectInputValue, setmessgeraettypSelectInputValue] = React.useState('');
    const [wartungsintervallInputValue, setWartungsintervallInputValue] = React.useState('');

    if (viewMode)
        return (
            <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
                <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
                    <div >
                        <Grid container spacing={4}>
                            <Grid item container xs={12}>
                                <Grid item md={3}>
                                <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                                    {newEntry ? "Neues Messgerät anlegen" : "Bearbeiten von Messgerät: " + aktuellesMessgeraet.seriennummer}
                                </Typography>
                            </Grid>
                            <Grid item md={3} />
                            <Grid item md={6}>
                                {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                            </Grid>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <TextField
                                        required={true}
                                        disabled={!editEntry}
                                        id="messgeraet-seriennummer"
                                        error={validate(dispatch, setError, resetError, aktuellesMessgeraet.seriennummer, "serienummer")}
                                        helperText={validateHelper(aktuellesMessgeraet.seriennummer)}
                                        label="Seriennummer"
                                        variant="outlined"
                                        onChange={(event) => dispatch(setSeriennummer(event.target.value))}
                                        value={aktuellesMessgeraet.seriennummer}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <MuiPickersUtilsProvider  locale={de} utils={DateFnsUtils}>
                                        <DatePicker
                                            id="messstelle-herstellungsjahr"
                                            disabled={!editEntry}
                                            okLabel="OK"
                                            cancelLabel="ABBRECHEN"
                                            openTo="year"
                                            required={true}
                                            views={["year"]}
                                            label="Herstellungsjahr"
                                            inputVariant="outlined"
                                            value={new Date(aktuellesMessgeraet.herstellungsjahr, 1, 1)}
                                            onChange={(event) => dispatch(setHerstellungsjahr(event ? event?.getFullYear() : 0))}
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <TextField id="messstelle-firmware" disabled={!editEntry}
                                        label="Firmware" variant="outlined"
                                        required={true}
                                        error={validate(dispatch, setError, resetError, aktuellesMessgeraet.firmware, "firmware")}
                                        helperText={validateHelper(aktuellesMessgeraet.firmware)}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(event) => dispatch(setFirmware(event.target.value))}
                                        value={aktuellesMessgeraet.firmware ? aktuellesMessgeraet.firmware : ""} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <TextField id="messstelle-macadresse"
                                        error={validate(dispatch, setError, resetError, aktuellesMessgeraet.macadresse, "mac")}
                                        helperText={validateHelper(aktuellesMessgeraet.macadresse)}
                                        inputProps={{ maxLength: 255 }}
                                        label="MAC Adresse"
                                        disabled={!editEntry}
                                        variant="outlined"
                                        onChange={(event) => dispatch(setMACAdresse(event.target.value))}
                                        value={aktuellesMessgeraet.macadresse ? aktuellesMessgeraet.macadresse : ""} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                                    <DatePicker
                                        className={classes.datePicker}
                                        disabled={!editEntry}
                                        value={aktuellesMessgeraet.inbetriebnahmedatum}
                                        format="dd.MM.yyyy "
                                        label="Inbetriebnahmedatum"
                                        okLabel="OK"
                                        cancelLabel="ABBRECHEN"
                                        inputVariant="outlined"
                                        onChange={(event) => {
                                            dispatch(
                                                setInbetriebnahmedatum(event)
                                            );
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton onClick={() =>
                                                    dispatch(setInbetriebnahmedatum(null))
                                                }
                                                    disabled={!editEntry}>
                                                    <ClearIcon />
                                                </IconButton>
                                            )
                                        }}
                                    ></DatePicker>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <Autocomplete
                                        id="select-wartungsintervall"
                                        noOptionsText={<React.Fragment>
                                            {wartungsintervallLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Wartungsintervalle"}</React.Fragment>}
                                        disabled={!editEntry}
                                        value={aktuellesMessgeraet.wartungsintervall}
                                        onChange={(_, newValue) => {
                                            dispatch(setWartungsintervall(newValue));
                                        }}
                                        inputValue={wartungsintervallInputValue}
                                        onInputChange={(_, newInputValue) => {
                                            setWartungsintervallInputValue(newInputValue);
                                        }}
                                        options={
                                            wartungsintervalleSelectList.map((x: wartungsintervall) => x.name)}
                                        getOptionLabel={(option) => option ? option : ""}
                                        renderInput={(params) => <TextField {...params} label="Wartungsintervall" variant="outlined" />}
                                        className={classes.selectEmpty}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <Autocomplete
                                        id="select-zs"
                                        noOptionsText={<React.Fragment>
                                            {zeitsynchroLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Zeitsynchronisationsarten"}</React.Fragment>}
                                        disabled={!editEntry}
                                        value={aktuellesMessgeraet.zeitsynchronisationsart}
                                        onChange={(_, newValue) => {
                                            dispatch(setZS(newValue));
                                        }}
                                        inputValue={zsSelectInputValue}
                                        onInputChange={(_, newInputValue) => {
                                            setZSSelectInputValue(newInputValue);
                                        }}
                                        options={
                                            zsSelectList.map((x: zeitsynchronisationsart) => x.name)}
                                        getOptionLabel={(option) => option ? option : ""}
                                        renderInput={(params) => <TextField {...params} label="Zeitsynchronisationsart" variant="outlined" />}
                                        className={classes.selectEmpty}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <Autocomplete
                                        id="select-typ"
                                        noOptionsText={<React.Fragment>
                                            {messgeraettypenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Messgrättypen"}</React.Fragment>}
                                        disabled={editEntry ? false : true}
                                        value={messgeraettypSelectList.find((x: messgeraettyp) => x.id == aktuellesMessgeraet.typ)}
                                        onChange={(_, newValue) => {
                                            if (newValue) dispatch(setMessgeraetetyp(newValue.id));
                                        }}
                                        inputValue={messgeraettypSelectInputValue}
                                        onInputChange={(_, newInputValue) => {
                                            setmessgeraettypSelectInputValue(newInputValue);
                                        }}

                                        options={messgeraettypSelectList}
                                        getOptionLabel={(option) => option ? option.hersteller + ": " + option.typ : ""}
                                        renderInput={(params) => <TextField {...params} label="Messgerättyp" variant="outlined" required={true} />}
                                        className={classes.selectEmpty}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <TextField id="messgeraet-ip" disabled={!editEntry}
                                        label="IP-Adresse" variant="outlined"
                                        error={validate(dispatch, setError, resetError, aktuellesMessgeraet.ipadresse, "ip")}
                                        helperText={validateHelper(aktuellesMessgeraet.ipadresse)}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(event) => dispatch(setIp(event.target.value))}
                                        value={aktuellesMessgeraet.ipadresse ? aktuellesMessgeraet.ipadresse : ""} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl className={classes.fullWidth}>
                                    <TextField id="messgeraet-subnetzmaske"
                                        inputProps={{ maxLength: 50 }}
                                        error={validate(dispatch, setError, resetError, aktuellesMessgeraet.subnetzmaske, "subnetzmaske")}
                                        helperText={validateHelper(aktuellesMessgeraet.subnetzmaske)}
                                        label="Subnetzmaske"
                                        disabled={!editEntry}
                                        variant="outlined"
                                        onChange={(event) => dispatch(setSubnetzmaske(event.target.value))}
                                        value={aktuellesMessgeraet.subnetzmaske ? aktuellesMessgeraet.subnetzmaske : ""} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl className={classes.fullWidth}>
                                    <TextField id="messstelle-kommentar"
                                        multiline
                                        rows={4}
                                        rowsMax={8}
                                        label="Kommentar" disabled={!editEntry} variant="outlined" onChange={(event) => dispatch(setKommentar(event.target.value))} value={aktuellesMessgeraet.kommentar ? aktuellesMessgeraet.kommentar : ""} />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </Paper>
        );
    else {
        return (<React.Fragment />)
    }

}
